import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft, Lock, Sparkles } from "lucide-react";
import { MotionConfig } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { useReducedMotion, setReducedMotion } from "../lib/motionPref";

export const PageShell = ({ back, backLabel = "Journey", label, title, subtitle, children, wide }) => {
  const navigate = useNavigate();
  return (
    <div className={`min-h-screen px-5 md:px-8 py-6 mx-auto ${wide ? "max-w-7xl" : "max-w-4xl"}`}>
      <div className="flex items-center justify-between mb-8 gap-3">
        <button onClick={() => navigate(back)} className="btn-pill text-xs" data-testid="page-back-btn">
          <ChevronLeft size={14} /> {backLabel}
        </button>
        <div className="font-mono-label text-white/50 text-right">{label}</div>
      </div>
      {title && <h1 className="text-3xl md:text-5xl font-display font-light leading-tight mb-3">{title}</h1>}
      {subtitle && <p className="text-sm md:text-base text-white/55 mb-10 max-w-2xl">{subtitle}</p>}
      {children}
    </div>
  );
};

export const PremiumNotice = ({ feature }) => (
  <div className="glass rounded-3xl p-8 text-center max-w-xl mx-auto" data-testid="premium-notice">
    <Lock className="mx-auto mb-3 text-amber-300" />
    <h2 className="font-display text-2xl mb-2">{feature} is a Premium experience</h2>
    <p className="text-sm text-white/55 mb-6">The core multiverse stays free. Premium unlocks more selves, deeper conversations and the advanced tools.</p>
    <Link to="/pricing" className="btn-pill btn-pill-gold" data-testid="premium-notice-upgrade"><Sparkles size={14} /> See plans</Link>
  </div>
);

export const GlobalNav = () => {
  const { user, logout } = useAuth();
  const reduced = useReducedMotion();
  return (
    <MotionConfig reducedMotion={reduced ? "always" : "never"}>
      <div className="fixed top-3 right-3 z-[60] flex items-center gap-2 text-[11px]" data-testid="global-nav">
        <button onClick={() => setReducedMotion(!reduced)} className="glass rounded-full px-3 py-1.5 text-white/60 hover:text-white" data-testid="reduced-motion-toggle" aria-pressed={reduced}>
          {reduced ? "Motion: reduced" : "Motion: full"}
        </button>
        <Link to="/pricing" className="glass rounded-full px-3 py-1.5 text-amber-200/80 hover:text-amber-100" data-testid="nav-pricing">{user?.is_premium ? "Premium" : "Plans"}</Link>
        {user ? (
          <button onClick={logout} className="glass rounded-full px-3 py-1.5 text-white/60 hover:text-white" data-testid="nav-logout">Sign out</button>
        ) : (
          <Link to="/login" className="glass rounded-full px-3 py-1.5 text-white/60 hover:text-white" data-testid="nav-login">Sign in</Link>
        )}
      </div>
    </MotionConfig>
  );
};
